<div class="footer" fxLayout="row">
  <div fxFlex="auto" fxLayout="row" fxLayoutAlign="end center" vexContainer>
    <p class="caption">by <a href="https://kracik.sk" class="text-accent">kracik.sk</a> 🔥 {{ version }}</p>
  </div>
</div>
